module.exports = __webpack_public_path__ + "static/img/brees-2007-img-in-copy.5b09bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-img-in-copy.png
// module id = VI2b
// module chunks = 1